import { tenant } from '@tenant';
import cn from 'classnames';

import type { CollectionPaymentStatus } from 'api';

interface PaymentStateBadge {
  class: string;
  text: string;
}

type PaymentStateBadges = {
  [key in CollectionPaymentStatus]: PaymentStateBadge;
};

interface PaymentBadgeProps {
  type: CollectionPaymentStatus;
}

const badges: PaymentStateBadges = {
  created: {
    class: 'bg-feedback-info-surface',
    text: 'Created'
  },
  consent_required: {
    class: 'bg-status-action-required',
    text: 'Consent Required'
  },
  kyc_required: {
    class: 'bg-status-action-required',
    text: 'KYC Required'
  },
  processing: {
    class: 'bg-status-processing',
    text: 'Processing'
  },
  user_authorised: {
    class: 'bg-status-processing',
    text: 'User authorised'
  },
  consent_given: {
    class: 'bg-status-completed',
    text: 'Consent Given'
  },
  extra_info_required: {
    class: 'bg-status-action-required',
    text: 'Extra Info Required'
  },
  bank_info_collected: {
    class: 'bg-status-completed',
    text: 'Bank Info Collected'
  },
  external_request_created: {
    class: 'bg-feedback-info-surface',
    text: 'External Request Created'
  },
  bank_authorised: {
    class: 'bg-feedback-info-surface',
    text: 'Bank Authorised'
  },
  bank_processing: {
    class: 'bg-feedback-info-surface',
    text: 'Bank Processing'
  },
  completed: {
    class: 'bg-status-completed',
    text: 'Completed'
  },
  external_transfer_required: {
    class: 'bg-status-action-required',
    text: 'External Transfer Required'
  },
  redirect_to_bank: {
    class: 'bg-status-returned',
    text: 'Redirect To Bank'
  },
  bank_rejected: {
    class: 'bg-status-negative',
    text: 'Rejected'
  },
  user_cancelled: {
    class: 'bg-status-negative',
    text: 'User Cancelled'
  },
  instructions_provided: {
    class: 'bg-feedback-info-surface',
    text: 'Bank Processing'
  },
  sum_too_low: {
    class: 'bg-status-negative',
    text: 'Rejected'
  },
  sum_too_high: {
    class: 'bg-status-negative',
    text: 'Rejected'
  },
  refunded: {
    class: 'bg-status-completed',
    text: 'Completed'
  },
  extra_bank_info_required: {
    class: 'bg-status-action-required',
    text: 'External Transfer Required'
  },
  redirected_to_inpay: {
    class: 'bg-status-returned',
    text: `Redirect To ${tenant.name.company}`
  },
  returned_from_provider: {
    class: 'bg-status-returned',
    text: `Returned from ${tenant.name.company}`
  }
};

export const PAYMENT_BADGE_TEST_ID =
  'order-details_payment-badge_status-status';

export const PaymentBadge = ({ type }: PaymentBadgeProps) => {
  const badge = badges[type];

  if (!badge) {
    console.error(`invalid badge from type ${type}`);
    return null;
  }

  return (
    <span
      data-testid={PAYMENT_BADGE_TEST_ID}
      className={cn(
        badge.class,
        'inline-block w-fit overflow-hidden truncate rounded-2xl px-2 py-1 text-sm'
      )}
    >
      {badge.text}
    </span>
  );
};
